import { useState } from "react";
import DatePicker from "react-datepicker";
import { Card, CardBody, Col } from "reactstrap";

const CalenderCard = () => {
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const handleChange = (date: Date | null) => {
    setStartDate(date);
  };

  return (
    <Col xl="4" md="6" sm="12" className="d-xxl-block d-xl-none box-col-6">
      <Card className="general-cal" style={{ minHeight: "369.594px" }}>
        <CardBody className="cal-date-widget d-flex align-items-center justify-content-center">
          <div className="cal-datepicker">
            <div className="datepicker-here float-sm-end">
              <DatePicker onChange={handleChange} selected={startDate} inline />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CalenderCard;
